import { render, staticRenderFns } from "./aggregation.vue?vue&type=template&id=77006996&"
import script from "./aggregation.vue?vue&type=script&lang=js&"
export * from "./aggregation.vue?vue&type=script&lang=js&"
import style0 from "./aggregation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports